package com.patronat.top.ui.molecules.alerts

import androidx.compose.animation.*
import androidx.compose.foundation.layout.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.theme.AppIcons

data class AlertUiModel(
    val title: String,
    val message: String,
    val icon: Painter? = null
)

enum class GlobalAlertStyle {
    Toast,
    MobileBanner
}

@Composable
fun GlobalAlertOverlay(
    alertData: AlertUiModel?,
    style: GlobalAlertStyle = GlobalAlertStyle.Toast,
    content: @Composable () -> Unit
) {
    Box(modifier = Modifier.fillMaxSize()) {

        content()

        when (style) {
            GlobalAlertStyle.Toast -> {
                AnimatedVisibility(
                    visible = alertData != null,
                    enter = slideInHorizontally(initialOffsetX = { it }) + fadeIn(),
                    exit = slideOutHorizontally(targetOffsetX = { it }) + fadeOut(),
                    modifier = Modifier
                        .align(Alignment.TopEnd)
                        .statusBarsPadding()
                        .padding(top = 16.dp, end = 16.dp)
                        .widthIn(max = 400.dp)
                        .wrapContentHeight()
                ) {
                    alertData?.let { data ->
                        AppAlert(
                            title = data.title,
                            message = data.message,
                            icon = data.icon ?: AppIcons.AlertWarning
                        )
                    }
                }
            }

            GlobalAlertStyle.MobileBanner -> {
                AnimatedVisibility(
                    visible = alertData != null,
                    enter = slideInVertically(initialOffsetY = { -it }) + fadeIn(),
                    exit = slideOutVertically(targetOffsetY = { -it }) + fadeOut(),
                    modifier = Modifier
                        .align(Alignment.TopCenter)
                        .statusBarsPadding()
                        .padding(start = 16.dp, top = 16.dp, end = 16.dp)
                        .fillMaxWidth()
                        .wrapContentHeight()
                ) {
                    alertData?.let { data ->
                        AppMobileAlert(
                            title = data.title,
                            message = data.message,
                            icon = data.icon
                        )
                    }
                }
            }
        }
    }
}
